<table
  #tableElement
  class="cg-datatable"
  matSort
  (matSortChange)="sortData($event)"
>
  <thead>
    <tr class="cg-hide-for-print">
      <th
        *ngIf="tableView === 'confirm'"
        style="width: 55px"
        class="cg-datatable__header cg-datatable__header-checkbox"
      >
        <!-- Select -->
        <input
          class="cg-datatable__header-checkbox-input"
          type="checkbox"
          (change)="selectAllUsers($event)"
          data-test="wam-table-header-checkbox"
        />
      </th>
      <th
        style="width: 250px"
        mat-sort-header="lastName"
        class="cg-datatable__header cg-datatable__header--sortable"
      >
        User
      </th>
      <th *ngIf="tableView !== 'lob-pref'" class="cg-datatable__header">
        <div class="nosort-header-container">TINs</div>
      </th>
      <th
        *ngIf="
          shouldShowPrefLob || (tableView === 'review' && userType !== 'new')
        "
        class="cg-datatable__header"
      >
        <div class="nosort-header-container">Line of Business</div>
      </th>
    </tr>
  </thead>
  <tbody>
    <tr
      *ngFor="let user of sortedData; index as userIndex"
      class="cg-print-item-fullpage cg-print-hide-table-borders"
      [class.cg-hide-for-print]="!selectedForPrintEmail(user)"
    >
      <td
        *ngIf="tableView === 'confirm'"
        class="cg-datatable__cell cg-datatable__cell--centered cg-hide-for-print"
      >
        <input
          type="checkbox"
          (change)="selectUser(user, $event)"
          data-test="chk-' + user.firstName + '-' + user.lastName"
        />
      </td>
      <td
        class="cg-datatable__cell"
        [attr.data-test]="
          'td-userDetails-' + user.firstName + '-' + user.lastName
        "
      >
        <cigna-user-summary-item
          mode="view"
          [user]="user"
          [allowRemove]="false"
          [allowView]="false"
          (viewAccessForUser)="openUserAccessDialog($event)"
        >
        </cigna-user-summary-item>
      </td>
      <td
        *ngIf="tableView !== 'lob-pref'"
        class="cg-datatable__cell"
        data-test="'lbl-tin-info-' + user.firstName + '-' + user.lastName"
      >
        <cigna-user-access-diff
          [user]="user"
          [userType]="userType"
          [isVendorSuccess]="isVendorSuccess"
        >
        </cigna-user-access-diff>
      </td>

      <td
        *ngIf="
          shouldShowPrefLob || (tableView === 'review' && userType !== 'new')
        "
        class="cg-datatable__cell"
        data-test="'lbl-lob-info-' + user.firstName + '-' + user.lastName"
      >
        <cigna-user-lob
          [user]="user"
          [canEdit]="
            tableView === 'lob-pref' ||
            (tableView === 'review' && userType !== 'new')
          "
        ></cigna-user-lob>
      </td>
    </tr>
  </tbody>
</table>
